const miniCartOnHover = window.theme.miniCartHover;
const pageType = window.theme.pageType;
const cartIcon = document.querySelector('.header__action-item--cart');
const miniCart = document.getElementById('mini-cart');

function openMiniCart() {
  if (miniCart.getAttribute("aria-hidden") === "true") {
    miniCart.setAttribute("aria-hidden", "false");
  }
}

function closeMiniCart() {
  if (miniCart.getAttribute("aria-hidden") === "false") {
    miniCart.setAttribute("aria-hidden", "true");
  }
}

function handleMiniCartOnHover (screenMatch, hasMouse) {
  if (screenMatch === true && hasMouse === true && pageType !== 'cart') {
    cartIcon.addEventListener("mouseenter", openMiniCart);
    cartIcon.addEventListener("mouseleave", closeMiniCart);
  } else {
    cartIcon.removeEventListener("mouseenter", openMiniCart);
    cartIcon.removeEventListener("mouseleave", closeMiniCart);
  }
}


function checkScreenWidth() {
  const screenWidth = window.innerWidth;
  return screenWidth >= 641;
}

function hasMouse() {
  return matchMedia('(pointer:fine)').matches;
}

if (miniCartOnHover === true && cartIcon && miniCart) {
  handleMiniCartOnHover(checkScreenWidth(), hasMouse());
  window.addEventListener("resize", function () {
    handleMiniCartOnHover(checkScreenWidth(), hasMouse());
  });
}